<div class="dialog-container expand">
  <div class="dialog-title">
    <div class="dialog-close" (click)="dialogRef.close()"><i class="mdi mdi-close"></i></div>
    {{"PAYMENT.DIALOG." + title | translate}}
  </div>
  <div class="dialog-body">
    <div class="debit-card-box">
      <img src="./assets/svg/debit-card.svg">
    </div>
    <div class="add-card-form" [hidden]="!showAddCardForm">
      <form novalidate (ngSubmit)="addCard(addCardForm)" [formGroup]="addCardForm">
        <div class="form-text">
          {{"PAYMENT.DIALOG.CARD" | translate}}
        </div>
        <div id="card-element" class="field card"></div>
        <div class="form-text">
          {{"PAYMENT.DIALOG.BILLINGTEXT" | translate}}
        </div>
        <div class="field">
          <input type="text" name="name" formControlName="name" [placeholder]="'PAYMENT.DIALOG.FULLNAME' | translate">
        </div>
        <div class="field">
          <input type="text" name="address_line1" formControlName="address_line1"
                 [placeholder]="'PAYMENT.DIALOG.ADDRESS' | translate">
        </div>
        <div class="field">
          <input type="text" name="address_line2" formControlName="address_line2"
                 [placeholder]="'PAYMENT.DIALOG.APT' | translate">
        </div>
        <div class="field">
          <input type="text" name="address_zip" formControlName="address_zip"
                 [placeholder]="'PAYMENT.DIALOG.ZIP' | translate"
                 [textMask]="{mask: zipCodeMask}">
        </div>
        <div class="field">
          <input type="text" name="address_city" formControlName="address_city"
                 [placeholder]="'PAYMENT.DIALOG.CITY' | translate">
        </div>
        <div class="field">
          <input type="text" name="address_state" formControlName="address_state"
                 [placeholder]="'PAYMENT.DIALOG.STATE' | translate">
        </div>
        <div class="field">
          <input type="text" name="address_country" formControlName="address_country"
                 [placeholder]="'PAYMENT.DIALOG.COUNTRY' | translate">
        </div>
        <div class="btns">
          <button class="w-link-btn" type="button" (click)="cancelForm()">
            {{'CANCEL' | translate}}
          </button>
          <button class="w-btn btn-wave blue-btn" type="submit">{{'PAYMENT.DIALOG.ADDCARD' | translate}}</button>
        </div>
      </form>
    </div>
    <div class="cards-list" [hidden]="showAddCardForm">
      <ul>
        <li *ngFor="let card of cards">
          <div (click)="setDefaultCard(card.id)">
            <div class="icon">
              <i class="mdi mdi-credit-card"></i>
            </div>
            <div class="card-text">
              <span>{{card.brand}}</span> {{'PAYMENT.DIALOG.ENDING' | translate}} <span>{{card.last4}}</span>
            </div>
            <div class="default-icon" *ngIf="defaultCard == card.id">
              <i class="mdi mdi-check"></i>
            </div>
          </div>
          <div class="remove-btn" *ngIf="defaultCard != card.id" (click)="deleteCard(card.id)">
            <i class="mdi mdi-close"></i>
          </div>
        </li>
        <li (click)="showAddCardForm = true">
          <div class="icon">
            <i class="mdi mdi-plus"></i>
          </div>
          <div class="card-text">
            <span>
              {{'PAYMENT.DIALOG.ADDTEXT' | translate}}
            </span>
          </div>
        </li>
      </ul>
    </div>
    <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
  </div>
</div>
